import {Pipe, PipeTransform} from '@angular/core';

/**
 *
 */
@Pipe({name: 'shortString'})
export class ShortString implements PipeTransform {
  /**
   *
   * @param value
   * @returns {number}
   */
  transform(value: string): any {
    const returnArray = [];
    if (value) {
      const stringArray = value.split(' ');
      for (let i = 0; i < stringArray.length; i++) {
        returnArray.push(stringArray[i].split('')[0]);
      }
      return returnArray.toString().replace(/,/g, '').toUpperCase();
    }
  }
}
